import { ActionResponse } from 'src/app/models/action-response';
import { BillingItem } from 'src/app/models/billingitem';
import { BillingAccount } from 'src/app/models/vendor-account';

export interface State {
  servicesStep: BillingItem[];
  billingaccountsStep: BillingAccount[];
  response: ActionResponse;
  errorMessage: string;
}

export const initialState: State = {
  servicesStep: null,
  billingaccountsStep: null,
  response: null,
  errorMessage: null,
};
